import Dropdown from "@elsa-zku/lib/components/Dropdown";
import * as React from 'react';
import ProfileAvatar from "@elsa-zku/lib/components/Avatar/ProfileAvatar";
import Icon from "@elsa-zku/lib/components/Icon";
import { unauth, useUser } from "src/store/user";
import style from './Header.scss';
import Button from "@elsa-zku/lib/components/Button";
import HeaderProfile from "@elsa-zku/lib/components/HeaderProfile";

type Props = {};

const Header: React.FC<Props> = (props) => {
  const user = useUser();

  return (
    <div className={style.container}>
      <div className={style.left}>
      </div>
      <div className={style.aside}>
        <Button outline size="sm" tag="a" href="https://myelsa.kaiten.ru/sd/requests" target="_blank">
          Написать в техподдержку
        </Button>

        {user && (
          <Dropdown
            renderDropdown={() => <HeaderProfile user={user}/>}
          >
            {({ onActivate, elementRef }) => (
              <div className={style.right} ref={elementRef}>
                <div className={style.profile} onClick={onActivate}>
                  <div className={style.name}>{user.name}</div>
                  <ProfileAvatar user={user} size="40px"/>
                </div>
              </div>
            )}
          </Dropdown>
        )}
      </div>
    </div>
  );
}

export default React.memo(Header);
